var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.badge, ( _obj = {}, _obj[_vm.$style.user] = _vm.badgeType=='user', _obj ), ( _obj$1 = {}, _obj$1[_vm.$style.faculty] = _vm.badgeType=='faculty', _obj$1 )]})}
var staticRenderFns = []

export { render, staticRenderFns }